import React, { useMemo } from "react";
import { NavLink, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearSuperadminRefreshToken } from "../../redux-toolkit/reducer/superadminRefreshToken_reducer";
import "../../loader.js";
import { AiFillSetting } from "react-icons/ai";
import { AiOutlinePoweroff } from "react-icons/ai";
import { BiHelpCircle } from "react-icons/bi";
import { useHistory } from "react-router-dom";
import SidebarItem from "./sidebarItem.jsx";
import { modules } from "../../constants/constants.js";
import { httpSuperAdmin } from "../../Apis/commonApis.jsx";

function Sidebar() {
  const history = useHistory();
  const dispatch = useDispatch();
  async function verifyLogout() {
    try {
      const response = await httpSuperAdmin("logout", {});
    } catch (error) {console.log(error, 'eelogout')}
    // Clear refresh tokens from Redux store and localStorage
    dispatch(clearSuperadminRefreshToken());

    // Clear other tokens from localStorage
    localStorage.removeItem("currentCareSiteId");
    localStorage.removeItem("superadmin_token");
    localStorage.removeItem("superadmin_access_token_expiry");
    localStorage.removeItem("superadmin_refresh_token");
    localStorage.removeItem("__csadmin__d");

    // Redirect to login page
    history.replace("/superadmin/login");
  }

  const filteredModuleWithAccess = useMemo(() => {
    let roleAccess = JSON.parse(localStorage.getItem("__csadmin__d"));
    const roleModuls = roleAccess?.role[0]?.Modules;
    if (!roleModuls) {
      verifyLogout();
    }

    const moduleAccessMap = roleModuls?.reduce((acc, curr) => {
      acc[curr.moduleName] = curr.access;
      return acc;
    }, {});
    const m1 = modules
      .slice(0, 6)
      .filter((mItem) => moduleAccessMap[mItem.label] !== "no");
    const m2 = modules
      .slice(6, 8)
      .filter((mItem) => moduleAccessMap[mItem.label] !== "no");
    console.log(roleAccess, "rrrrrrrrrrrrrr");
    return { m1, m2 };
  }, []);

  return (
    <aside className="super-left-sidebar col-md-4">
      <div className="super-scroll-sidebar">
        <nav className="super-sidebar-nav">
          <ul id="sidebarnav">
            <h5>Subscription Hub</h5>
            {filteredModuleWithAccess?.m1?.map((item, index) => (
              <SidebarItem
                key={index}
                links={item.link}
                src={item.src}
                sidebarName={item.label}
              />
            ))}
            <h5 className="mt-5"></h5>
            {filteredModuleWithAccess?.m2?.map((item, index) => (
              <SidebarItem
                key={index}
                links={item.link}
                src={item.src}
                sidebarName={item.label}
              />
            ))}
          </ul>
        </nav>
      </div>
      <div className="sidebar-footer d-flex justify-content-around">
        <Link
          to="/superadmin/settings/company"
          className="link"
          style={{ color: "white" }}
          title="Setting"
        >
          <AiFillSetting />
        </Link>
        <NavLink
          to="#"
          className="link"
          style={{ color: "white" }}
          title="Help Resources"
        >
          <BiHelpCircle />
        </NavLink>
        <Link
          to="/superadmin/login"
          className="link"
          style={{ color: "white" }}
          title="Logout"
        >
          <AiOutlinePoweroff
            onClick={() => {
              verifyLogout();
            }}
          />
        </Link>
      </div>
    </aside>
  );
}

export default Sidebar;
